import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames/bind';
import 'swiper/css';
import { enhancedConnect } from "../../utils";
import styles from "./styles.pcss";
import { useCarousel } from "./useCarousel";
var cx = classNames.bind(styles);
var _Carousel = function _Carousel(_ref) {
  var children = _ref.children,
    classname = _ref.classname,
    spaceBetween = _ref.spaceBetween,
    _ref$centeredSlides = _ref.centeredSlides,
    centeredSlides = _ref$centeredSlides === void 0 ? true : _ref$centeredSlides,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? true : _ref$autoplay,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    style = _ref.style,
    _ref$shouldChangeSlid = _ref.shouldChangeSlideOnClick,
    shouldChangeSlideOnClick = _ref$shouldChangeSlid === void 0 ? true : _ref$shouldChangeSlid;
  var _useCarousel = useCarousel({
      autoplay: autoplay
    }),
    ref = _useCarousel.ref,
    setInstance = _useCarousel.setInstance,
    handleSlideClick = _useCarousel.handleSlideClick,
    activeIndex = _useCarousel.activeIndex;
  return /*#__PURE__*/React.createElement("section", {
    className: cx('container', classname),
    ref: ref,
    "data-t-id": "components-Carousel"
  }, /*#__PURE__*/React.createElement(Swiper, {
    centeredSlides: centeredSlides,
    className: cx('carousel', type === 'cards' && 'carousel-cards'),
    onSwiper: setInstance,
    slidesPerView: "auto",
    spaceBetween: spaceBetween,
    style: style
  }, React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      className: cx('slide', {
        'slide-active': activeIndex === index
      }),
      onClick: shouldChangeSlideOnClick ? handleSlideClick(index) : undefined
    }, child);
  })));
};
export var Carousel = enhancedConnect()(_Carousel);
export { CarouselActiveLogic } from "./CarouselActiveLogic";
export { CarouselBanner } from "./CarouselBanner";
export { CarouselBannerGroup } from "./CarouselBannerGroup";
export { CarouselContainer } from "./CarouselContainer";
export { CarouselDiv } from "./CarouselDiv";
export { CarouselHeader } from "./CarouselHeader";
export { CarouselNavigation } from "./CarouselNavigation";
export { CarouselNavigationButtons } from "./CarouselNavigationButtons";
export { CarouselArrow } from "./CarouselNavigationButtons/CarouselArrow";
export { CarouselSlide } from "./CarouselSlide";
export { CarouselSlideBanner } from "./CarouselSlideBanner";
export { CarouselSlideLottie } from "./CarouselSlideLottie";